module.exports = __webpack_public_path__ + "static/educative-quiz-f364a5ecdf182d089ddc0388fe2739d5.webm";